import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductDetailsKitSectionDetails from "@MasterBluePrint/Components/ProductDetailsKitSectionDetails";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    configuration?: ProductModel[] | null | undefined;
    kitText: boolean;
    title: string;
}

type Props = OwnProps;

export interface ProductDetailsKitSectionOptionsStyles {
    wrapper?: InjectableCss;
    configSectionWrapper?: InjectableCss;
    configSectionLabel?: TypographyPresentationProps;
    sectionOptionText?: TypographyPresentationProps;
}

export const productDetailsKitSectionOptionsStyles: ProductDetailsKitSectionOptionsStyles = {
    wrapper: {
        css: css`
            margin-bottom: .625rem;
            line-height: 1.5625rem;
        `,
    },
    configSectionLabel: {
        weight: "bold",
        css: css`
            display: block;
        `,
    },
    sectionOptionText: {
        css: css`
            display: block;

            @media (min-width: 768px) {
                &.kit-container {
                   display: inline-block;
                   width: 49%;
                   padding-right: 1rem;
                   padding-bottom: 0.5rem;
                }
            }
        `,
    },
};

const styles = productDetailsKitSectionOptionsStyles;
const ProductDetailsKitSection: React.FC<Props> = ({ configuration, kitText, title }) => {
    if (!configuration || configuration.length === 0) {
        return null;
    }
    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.configSectionWrapper}>
                {configuration.map((sectionOption,index) => (                   
                    <Typography {...styles.sectionOptionText} key={sectionOption.id} className="kit-container">
                        <ProductDetailsKitSectionDetails
                            option={sectionOption}
                            productIndex={index}
                            kitText={kitText}
                            title={title}
                        ></ProductDetailsKitSectionDetails>
                    </Typography>
                ))}
            </StyledWrapper>
        </StyledWrapper>
    );
};
export default ProductDetailsKitSection;
